import React from 'react';

import { NEXT_PUBLIC_KNOTCH_LC_POST_ACCOUNT_ID } from '../../../server/config';
import ContentTemplate from '../../components/ContentTemplate';
import Layout from '../../components/Layout/Layout';
import LearningCenterLayout from '../../components/LearningCenterLayout/LearningCenterLayout';
import LearningCenterSubnav from '../../components/LearningCenterSubnav/LearningCenterSubnav';
import {
    buildPrimaryPostPage,
    LayoutComponentProps,
} from '../../util/buildPrimaryPostPage';

export const LearnLayout: React.FC<LayoutComponentProps> = (props) => {
    return (
        <Layout
            head={props.head}
            menu={props.menu}
            preview={props.preview}
            NavComponent={LearningCenterSubnav}
        >
            {props.children && (
                <LearningCenterLayout>{props.children}</LearningCenterLayout>
            )}
        </Layout>
    );
};

const { getStaticProps, getStaticPaths, WrappedPage } =
    await buildPrimaryPostPage({
        site: 'LEARN',
        basePath: '/learn',
        ContentComponent: ContentTemplate,
        LayoutComponent: LearnLayout,
        knotchAccountId: NEXT_PUBLIC_KNOTCH_LC_POST_ACCOUNT_ID,
        contentType: 'B2C',
    });

export { getStaticProps, getStaticPaths };
export default WrappedPage;
